import React from "react";

const UploadCloudLightIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.44828 12.1724C4.44828 12.1724 3 11.931 3 10C3 8.34597 4.27972 6.99086 5.90304 6.87073C6.02369 4.71273 7.81183 3 10 3C12.1882 3 13.9763 4.71273 14.097 6.87073C15.7203 6.99086 17 8.34597 17 10C17 11.931 15.5517 12.1724 15.5517 12.1724",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1724 13.1379L10 10.7241L7.82759 13.1379",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 17V11.6896",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UploadCloudLightIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;